import { render, staticRenderFns } from "./CandidateAvatar.vue?vue&type=template&id=0c9afd6d&scoped=true&"
import script from "./CandidateAvatar.vue?vue&type=script&lang=js&"
export * from "./CandidateAvatar.vue?vue&type=script&lang=js&"
import style0 from "./CandidateAvatar.vue?vue&type=style&index=0&id=0c9afd6d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c9afd6d",
  null
  
)

export default component.exports